<template>
  <div class="flex items-center justify-between gap-[10px] flex-wrap">
    <UnpackedCard title="Komship">
      {{ komship }}
    </UnpackedCard>
    <UnpackedCard title="Non-Komship">
      {{ nonKomship }}
    </UnpackedCard>
    <UnpackedCard title="Marketplace">
      {{ marketplace }}
    </UnpackedCard>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import UnpackedCard from './UnpackedCard.vue'

/**
 * Component to show total unpacked orders
 */
export default {
  name: 'UnpackedOrder',
  components: {
    UnpackedCard,
  },
  computed: {
    ...mapState('unpackedOrders', ['komship', 'nonKomship', 'marketplace']),
  },
  created() {
    this.$store.dispatch('unpackedOrders/startPolling')
  },
  beforeDestroy() {
    this.$store.dispatch('unpackedOrders/stopPolling')
  },
}
</script>
